<form [formGroup]="agregarFormGrupo">
  <div class="row">
    <div class="col-lg-12">
      <app-lfsa-input [control]="this.agregarFormGrupo.get('id_promo')" [id]="'id_promo'" [isReadOnly]="true"
        [label]="'ID PROMO'" formControlName="id_promo" type="text"></app-lfsa-input>
    </div>
    <div class="col-lg-6">
      <app-lfsa-input [control]="this.agregarFormGrupo.get('id_grupo')" [id]="'id_grupo'" [isReadOnly]="_grupo"
        [label]="'Grupo'" formControlName="id_grupo" type="text"></app-lfsa-input>
    </div>
    <div class="col-lg-6">
      <app-lfsa-input [control]="this.agregarFormGrupo.get('dsca_grupo')" [id]="'dsca_grupo'"
        [label]="'Descripción'" formControlName="dsca_grupo" type="text"></app-lfsa-input>
    </div>
    <div class="col-lg-12">
      <app-lfsa-input [control]="this.agregarFormGrupo.get('cantidad')" [id]="'cantidad'"
        [label]="'Cantidad'" formControlName="cantidad" type="number"></app-lfsa-input>
    </div>
  </div>
  <app-lfsa-botones-formulario (devolverAccion)="accionesGrupo( $event )"
    [formularioValido]="(!agregarFormGrupo.invalid) ? false : true" [textBoton]="'Guardar'"
    class="row">
  </app-lfsa-botones-formulario>
</form>
